import cs from 'classnames';
import React from 'react';
import { Box, Text } from '@wix/design-system';
import { useScreenWidth } from '../../../../hooks/useScreenWidth';
import { useUouLanguage } from '../../../../hooks/useUouLanguage';
import s from './uouChatFooter.scss';

type UoUChatFooterProps = {
  showDisclaimer: boolean;
};

export const UoUChatFooter: React.FC<UoUChatFooterProps> = ({ showDisclaimer }) => {
  const { isMobile } = useScreenWidth();
  const language = useUouLanguage();
  const textSize = isMobile ? 'tiny' : 'small';

  return (
    <Box direction="vertical" align="center" className={s.footerContainer}>
      <Text size="tiny" className={s.poweredBy}>
        {language.ASA_STANDALONE_FOOTER_TITLE()}
      </Text>
      <div className={cs(s.disclaimerContainer, { [s.disclaimerContainerHidden]: !showDisclaimer })}>
        <Text className={s.disclaimerText} secondary size={textSize} textAlign="center">
          {language.ASA_STANDALONE_FOOTER_DISCLAIMER()}
        </Text>
      </div>
    </Box>
  );
};
